import React, { useState } from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { motion } from 'framer-motion';
import { CyberButton } from './CyberButton';
import { ProjectModal } from './ProjectModal';
export function Header() {
  const {
    language,
    setLanguage
  } = useLanguage();
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
  const navItems = [{
    name: language === 'fr' ? 'Services' : 'Services',
    href: '#services'
  }, {
    name: language === 'fr' ? 'Tarifs' : 'Pricing',
    href: '#pricing'
  }, {
    name: language === 'fr' ? 'Technologie' : 'Technology',
    href: '#technology'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const targetId = href.replace('#', '');
    const element = document.getElementById(targetId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <>
      <motion.header initial={{
      y: 0
    }} className="fixed top-0 left-0 right-0 z-50 px-4 sm:px-6 py-3 sm:py-4 bg-black/80 backdrop-blur-md border-b border-white/10" data-id="element-156">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-157">
          {/* Logo */}
          <a href="#" onClick={e => {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }} className="flex items-center" data-id="element-158">
            <img src="https://cdn.magicpatterns.com/uploads/bhj5bijn5GdNZbC3VKBdD1/Screenshot_2026-01-15_190938-removebg-preview.png" alt="TUIIT" className="h-6 sm:h-7 w-auto" data-id="element-159" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-160">
            {navItems.map(item => <a key={item.name} href={item.href} onClick={e => handleSmoothScroll(e, item.href)} className="text-sm font-medium text-gray-400 hover:text-cyan transition-colors tracking-wide uppercase" data-id="element-161">
                {item.name}
              </a>)}
          </nav>

          {/* Mobile Language Toggle */}
          <div className="flex md:hidden items-center gap-2" data-id="element-162">
            <button onClick={() => setLanguage('fr')} className={`px-2 sm:px-3 py-1 font-cyber text-[10px] sm:text-xs font-bold tracking-widest transition-all border ${language === 'fr' ? 'border-cyan text-cyan bg-cyan/10' : 'border-white/20 text-gray-500'}`} data-id="element-163">
              FR
            </button>
            <div className="w-px h-4 bg-white/20" data-id="element-164" />
            <button onClick={() => setLanguage('en')} className={`px-2 sm:px-3 py-1 font-cyber text-[10px] sm:text-xs font-bold tracking-widest transition-all border ${language === 'en' ? 'border-cyan text-cyan bg-cyan/10' : 'border-white/20 text-gray-500'}`} data-id="element-165">
              EN
            </button>
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:block" data-id="element-166">
            <CyberButton variant="primary" className="px-6 py-2 text-xs" onClick={() => setIsProjectModalOpen(true)} data-id="element-167">
              {language === 'fr' ? 'DÉMARRER PROJET' : 'START PROJECT'}
            </CyberButton>
          </div>
        </div>
      </motion.header>

      <ProjectModal isOpen={isProjectModalOpen} onClose={() => setIsProjectModalOpen(false)} data-id="element-168" />
    </>;
}